import styled from 'styled-components';
import { TabContentWrapper } from '../UI/styledConstants';

export const Wrapper = styled(TabContentWrapper)`
&.bbps{
   margin-top: 0;
   background-color: transparent;
}
.headingText{
	margin-bottom: 20px!important;
}
	.payee-actions {
		button {
			min-width: 80px;
		}
	}
`;
